import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const ParityMiss = z.object({
  /** Stable join key (mongo id or name) of the missing V1 entity. */
  key: z.string(),
  /** Human-readable label for the missing V1 entity. */
  label: z.string(),
});

const EntityParityResult = z.object({
  entity: z.enum(["tags", "macros", "rules"]),
  v1Count: z.number().int().nonnegative(),
  v2Count: z.number().int().nonnegative(),
  /** V1 rows with no V2 counterpart — a migration gap. */
  missingInV2: z.array(ParityMiss),
  parity: z.boolean(),
});

/**
 * On-demand tag/macro/rule + ticket-count reconciliation for a migrated team.
 * Runs the same source-of-truth parity check the migration's Temporal activity
 * uses (`compareSupportV2EntityParity`), read-only against Mongo + CRDB.
 */
export const getSupportV2EntityParity = {
  name: "getSupportV2EntityParity" as const,
  input: z.object({ teamId: zExt.objectId() }).strict(),
  output: z.object({
    overallParity: z.boolean(),
    /**
     * Direct V1-conversations vs V2-support_ticket count. Integers but NOT
     * nonnegative: a read failure reports -1/-1 (unavailable).
     */
    results: z.array(EntityParityResult),
  }),
};

export type SupportV2EntityParitySnapshot = z.infer<
  typeof getSupportV2EntityParity.output
>;
